/*eslint-disable */

// ─── Type Definitions ────────────────────────────────────────────────

interface ApiEndpoint {
  apiHost?: string;
  apiPath?: string;
}

interface KeycloakEndpoint extends ApiEndpoint {
  hideIncomplete?: boolean;
}

interface MetaTag {
  name?: string;
  content?: string;
  charset?: string;
  property?: string;
}

interface AppHead {
  titleTemplate: string;
  meta: MetaTag[];
}

interface AppConfig {
  title: string;
  website: string;
  helpline: string;
  description: string;
  head: AppHead;
}

interface EnvironmentConfig {
  isClientSite?: string;
  realm?: string;
  clientId?: string;
  host?: string;
  port?: number;
  sessionTimeout?: number;
  scheme?: string;
  stripeApiKey?: string;
  creditCardSurchargeRate?: number;
  defaultCountyCode?: string;
  iframeAppSrc?: string;
  iframeOriginSrc?: string;
  wageScapeSource?: string;
  hideIncomplete?: boolean;
  ADMIN?: ApiEndpoint;
  AIMATCHINGENGINE?: ApiEndpoint;
  GEO?: ApiEndpoint;
  PUBLIC?: ApiEndpoint;
  REPORT?: Pick<ApiEndpoint, "apiHost">;
  KEYCLOAK?: KeycloakEndpoint;
  TINYMCE_API_KEY?: string;
}

interface Config {
  isClientSite: string;
  realm: string;
  clientId: string;
  host: string;
  port: number;
  sessionTimeout: number;
  scheme: string;
  stripeApiKey: string;
  creditCardSurchargeRate: number;
  defaultCountyCode: string;
  iframeAppSrc: string;
  iframeOriginSrc: string;
  wageScapeSource: string;
  ADMIN: ApiEndpoint;
  AIMATCHINGENGINE: ApiEndpoint;
  GEO: ApiEndpoint;
  PUBLIC: ApiEndpoint;
  REPORT: Pick<ApiEndpoint, "apiHost">;
  KEYCLOAK: ApiEndpoint & { hideIncomplete: string };
  app: AppConfig;
  DATE_FORMAT: Intl.DateTimeFormatOptions;
  TINYMCE_API_KEY: string;
}

declare const environmentConfig: EnvironmentConfig;

// ─── Config ──────────────────────────────────────────────────────────

const environmentConfigData: EnvironmentConfig | null =
  !process?.env || process.env.NODE_ENV === "development" ? null : environmentConfig;
/*eslint-enable*/
const config: Config = {
  isClientSite: (environmentConfigData && environmentConfigData?.isClientSite) || "false",
  realm: environmentConfigData?.realm || "qjumpers",
  clientId: (environmentConfigData && environmentConfigData?.clientId) || "qjumpers",
  host: environmentConfigData?.host || "admin_ui_1",
  port: (environmentConfigData && environmentConfigData?.port) || 5005,
  sessionTimeout: (environmentConfigData && environmentConfigData?.sessionTimeout) || 86400000,
  scheme: (environmentConfigData && environmentConfigData?.scheme) || "http",
  stripeApiKey: (environmentConfigData && environmentConfigData?.stripeApiKey) || "pk_test_w7ahZw3KdrM3qpS200X44DUh",
  creditCardSurchargeRate: (environmentConfigData && environmentConfigData?.creditCardSurchargeRate) || 3,
  defaultCountyCode: (environmentConfigData && environmentConfigData?.defaultCountyCode) || "NZ",
  iframeAppSrc: (environmentConfigData && environmentConfigData?.iframeAppSrc) || "http://localhost:5500",
  iframeOriginSrc: (environmentConfigData && environmentConfigData?.iframeOriginSrc) || "http://localhost:5500",
  wageScapeSource:
    environmentConfigData?.wageScapeSource || "https://app.sigmacomputing.com/embed/1-5FDUW3M8WwMO3uiweGtY4K",
  ADMIN: {
    apiHost: (environmentConfigData && environmentConfigData?.ADMIN?.apiHost) || "http://admin_api_1:5001",
    apiPath: (environmentConfigData && environmentConfigData?.ADMIN?.apiPath) || "/api",
  },
  AIMATCHINGENGINE: {
    apiHost:
      (environmentConfigData && environmentConfigData?.AIMATCHINGENGINE?.apiHost) ||
      " https://aiengine-api.uat.qjumpers.co",
    apiPath: (environmentConfigData && environmentConfigData?.AIMATCHINGENGINE?.apiPath) || "/aimatching",
  },
  GEO: {
    apiHost:
      (environmentConfigData && environmentConfigData?.GEO?.apiHost) || "https://qjumpers-geonames.qa.qjumpers.co",
    apiPath: (environmentConfigData && environmentConfigData?.GEO?.apiPath) || "/api",
  },
  PUBLIC: {
    apiHost: (environmentConfigData && environmentConfigData?.PUBLIC?.apiHost) || "http://public_api_1:5007",
    apiPath: (environmentConfigData && environmentConfigData?.PUBLIC?.apiPath) || "/api",
  },
  REPORT: {
    apiHost: (environmentConfigData && environmentConfigData?.REPORT?.apiHost) || "http://report:5010",
  },
  KEYCLOAK: {
    apiHost:
      (environmentConfigData && environmentConfigData?.KEYCLOAK?.apiHost) || "http://keycloak:8080",
    apiPath: (environmentConfigData && environmentConfigData?.KEYCLOAK?.apiPath) || "/auth",
    hideIncomplete: JSON.stringify((environmentConfigData && environmentConfigData?.hideIncomplete) || false),
  },
  app: {
    title: "QJumpers",
    website: "http://qjumpers.com",
    helpline: "0800 758 673",
    description: "QJumpers Recruitment",
    head: {
      titleTemplate: "%s - QJumpers",
      meta: [
        { name: "description", content: "QJumpers Recruitment" },
        { charset: "utf-8" },
        { property: "og:site_name", content: "QJumpers Recruitment" },
        { property: "og:image", content: "" },
        { property: "og:locale", content: "en_US" },
        { property: "og:title", content: "QJumpers Recruitment" },
        { property: "og:description", content: "QJumpers Recruitment" },
        { property: "og:card", content: "summary" },
        { property: "og:site", content: "@QJumpers" },
        { property: "og:creator", content: "QJumpers" },
        { property: "og:image:width", content: "200" },
        { property: "og:image:height", content: "200" },
      ],
    },
  },
  DATE_FORMAT: { month: "2-digit", day: "2-digit", year: "numeric" },
  TINYMCE_API_KEY: environmentConfigData && environmentConfigData?.TINYMCE_API_KEY || process.env.REACT_APP_TINYMCE_API_KEY,
};

export default config;
export type { Config, EnvironmentConfig, ApiEndpoint };
